import { render, staticRenderFns } from "./versionlist.vue?vue&type=template&id=6e798aaa"
import script from "./versionlist.vue?vue&type=script&lang=js"
export * from "./versionlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports